"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchNamespaceProviderIssue } from "@/lib/api-client";

export function useNamespaceProviderIssue(namespaceId?: string) {
  return useQuery({
    queryKey: ["namespaceProviderIssue", namespaceId ?? "__disabled__"],
    queryFn: () => {
      if (!namespaceId) throw new Error("Namespace ID required");
      return fetchNamespaceProviderIssue(namespaceId);
    },
    enabled: Boolean(namespaceId),
    staleTime: 30_000,
    refetchInterval: 30_000,
    retry: 1,
  });
}
